import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'






var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
const Heading = [['Client'  ,'Invoice Number',  'Trip Id',"Bill Number",  'SRN Date', 'Product Code', 'MRP',  'Return qty- Landed', 'Return qty- Received', 'Return qty- Putaway Done', 'Return qty- GR Done'
]];






class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchSalesData = this.fetchSalesData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no : "",
      trip_id : "",
      product_code : "",

      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,

      from_date: "",
      to_date: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };
  onInvoiceChange = (evt) => {
    this.setState({
      invoice_no: evt.target.value,
    });
  };
  onTripChange = (evt) => {
    this.setState({
      trip_id : evt.target.value,
    });
  };
  onProductChange = (evt) => {
    this.setState({
      product_code : evt.target.value,
    });
  };

  fetchSalesData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      invoice_no : this.state.invoice_no,
      trip_id : this.state.trip_id,
      product_code : this.state.product_code,
    };
    addAnalytics('Report', 'Sales Return To GR Report', payload);
    API.post('/reports/salesreturntogrreports/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

        this.setState({ tableRows: this.assemblePosts(data.data ),orderData : data.data})

      })

      .then(async () => {

        this.setState({  isLoading: false })

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
        
          client: post.client,
          invoice_no : post.invoice_no,
          trip_id: post.trip_id,
          bill_number : post.bill_number,
          srn_date: post.srn_date,
          product_code : post.product_code,
          mrp : post.mrp,
          return_qty_landed : post.return_qty_landed,
          return_qty_received : post.return_qty_received,
          return_qty_putaway_done : post.return_qty_putaway_done,
          return_qty_gr_done : post.return_qty_gr_done,

        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: ' Client',
          field: 'client',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Invoice Number',
          field: 'invoice_no',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Trip Id',
          field: 'trip_id',
          sort: 'asc',
          width: 140,

        },
        {

          label: 'Bill Number',
          field: 'bill_number',
          width: 140,
          sort: 'asc',

        }, 
        {
          label: ' SRN Date',
          field: 'srn_date',
          sort: 'asc',
          width: 140,

        },

        {
          label: 'Product Code',
          field: 'product_code',
          width: 140,
          sort: 'asc',

        },
        {

          label: 'MRP',
          field: 'mrp',
          width: 140,
          sort: 'asc',

        },

        {
          label: 'Return qty- Landed',
          field: 'return_qty_landed',
          width: 140,
          sort: 'asc',

        },
   

        {

          label: 'Return qty- Received',
          field: 'return_qty_received',
          width: 140,
          sort: 'asc',

        },

        {

          label: 'Return qty- Putaway Done',
          field: 'return_qty_putaway_done',
          width: 140,
          sort: 'asc',

        },

        {

          label: 'Return qty- GR Done',
          field: 'return_qty_gr_done',
          width: 140,
          sort: 'asc',

        },

       

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
           <Overlay>
              <form className="form">
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                    <span className="filter_title">Filters</span>
                </div>
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">From Date</span>
                  <div style={{ position: 'relative' }}>

                    <DatePicker
                      selected={this.state.from_date}
                      onChange={this.FromDateChange}
                      className="ledger_fromdate"
                      placeholderText="From Date"
                      format='yyyy-MM-dd'

                    />
                     <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>

                  {this.state.showFromErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                  }
                   {this.state.dateOrderError && (
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                  )}
                  </div>
                </div>

           <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '8%' }}>
              <span className="date_title">To Date</span>
              <div style={{ position: 'relative' }}>
                <DatePicker
                  selected={this.state.to_date}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="To Date"
                />
               <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }
               {this.state.dateRangeError &&
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                }
              </div>
            </div>

            <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">Invoice Number</span>
                      <div style={{ position: 'relative' }}>
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "Invoice Number" onChange={this.onInvoiceChange}/>
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">Trip ID</span>
                      <div style={{ position: 'relative' }}>
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "Trip Id" onChange={this.onTripChange}/>
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">Product Code</span>
                      <div style={{ position: 'relative' }}>
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "Product code" onChange={this.onProductChange}/>
                </div>
              </div>

           <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable1 "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                    marginRight: '10px',
                  }}
                  id="button_view"
                  onClick={() => this.fetchSalesData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
             
               <Button
                type="button"
                className="btn btn-primary-outline"
                style={{
                    cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                    backgroundColor: '#FFFFFF',
                    padding: "5px 10px",
                    color: '#333333', // Set text color
                    display: 'flex',   // Use flexbox to align image and text
                    alignItems: 'center' // Center items vertically
                }}
                id="button_download"
                onClick={(e) => exportToCSV(this.state.filtered_orderData, "Sales Return To Gr Report", Heading)}
            >
                <img
                    src={DownloadIcon}
                    alt="Download"
                    style={{ width: '22px' }} // Adjust size as needed
                />
                Download
            </Button>
              </ButtonToolbar>
            </div>

          </form>
          </Overlay>

           {!this.state.showFetchBinData && (
          <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
             <img style={{width: '10%'}} src={EmptyDataIcon} />
              <p className="noDataTextStyle">
              Choose your filters from the available options. The data will display
            </p>
            <p className="noDataTextStyle2">
               here once the filters have been applied.
            </p>
          </div>


        )}

          {
            this.state.showFetchBinData && (

             <div>
            <div>

                <div className="date-container">
                 {From_Date_val}
                </div>


                <div className="date-container">
                 {to_Date_val}
                </div>
                 <div className="date-container">
                 {this.state.invoice_no}
                </div>


                <div className="date-container">
                 {this.state.trip_id}
                </div>

                 <div className="date-container">
                 {this.state.product_code}
                </div>

              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Sales Return To GR', 'datatable_pagination_change' )}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  // style={{ textAlign: "center" }}
                />
               </div>
            </div>
            </div>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));